import { Fragment } from 'react'
import { s, h } from '../lib/sx'
import { A } from '../lib/router'
import { company, footerOffices } from '../content/company'

const COMPANY_LINKS = [
  ['/about', 'About us'],
  ['/leadership', 'Leadership'],
  ['/safety', 'Safety & compliance'],
  ['/careers', 'Careers'],
  ['/news', 'News & insights'],
] as const

const WORK_LINKS = [
  ['/services', 'Services'],
  ['/sectors', 'Sectors'],
  ['/projects', 'Projects'],
  ['/quote', 'Request a quote'],
  ['/contact', 'Contact'],
] as const

const LEGAL_LINKS = [
  ['/paia', 'PAIA manual'],
  ['/privacy', 'Privacy'],
  ['/supplier-code', 'Supplier code of conduct'],
] as const

const linkStyle = s('color:#8C97A4;')
const linkHover = h('color:#FFFFFF;')

export function Footer() {
  return (
    <footer style={s('background:#1B2430;color:#8C97A4;')}>
      <div style={s('max-width:1320px;margin:0 auto;padding:clamp(48px,7vw,80px) clamp(18px,4vw,32px) 40px;display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,200px),1fr));gap:clamp(30px,4vw,48px);')}>
        <div>
          <img
            src="/logo/samloryx-logo-round.svg"
            alt="Samloryx Engineering"
            width={164}
            height={44}
            style={s('height:44px;width:auto;display:block;')}
          />
          <p style={s('font-size:14px;line-height:1.65;margin:22px 0 0;max-width:340px;')}>{company.footerBlurb}</p>
          <div style={s("font-family:'IBM Plex Mono',monospace;font-size:11.5px;line-height:1.9;margin-top:24px;color:#B8C0CA;")}>
            <div>{company.address}</div>
            <div>
              {company.phone} · {company.email}
            </div>
          </div>
        </div>

        <div>
          <div style={s("font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:0.18em;text-transform:uppercase;color:#F2F4F6;margin-bottom:18px;")}>Company</div>
          <div style={s('display:flex;flex-direction:column;gap:11px;font-size:14px;')}>
            {COMPANY_LINKS.map(([href, label]) => (
              <A key={href} href={href} style={linkStyle} className={linkHover}>
                {label}
              </A>
            ))}
          </div>
        </div>

        <div>
          <div style={s("font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:0.18em;text-transform:uppercase;color:#F2F4F6;margin-bottom:18px;")}>Work</div>
          <div style={s('display:flex;flex-direction:column;gap:11px;font-size:14px;')}>
            {WORK_LINKS.map(([href, label]) => (
              <A key={href} href={href} style={linkStyle} className={linkHover}>
                {label}
              </A>
            ))}
          </div>
        </div>

        <div>
          <div style={s("font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:0.18em;text-transform:uppercase;color:#F2F4F6;margin-bottom:18px;")}>Offices</div>
          <div style={s('font-size:14px;line-height:1.9;')}>
            {footerOffices.map((o, i) => (
              <div key={i}>{o}</div>
            ))}
          </div>
        </div>
      </div>

      <div style={s('border-top:1px solid #33404F;')}>
        <div style={s("max-width:1320px;margin:0 auto;padding:22px clamp(18px,4vw,32px);display:flex;justify-content:space-between;gap:24px;flex-wrap:wrap;font-family:'IBM Plex Mono',monospace;font-size:11px;letter-spacing:0.08em;color:#66707C;")}>
          <span>
            © {new Date().getFullYear()} {company.legalName} · Reg. {company.registrationNumber}
          </span>
          <span style={s('display:flex;gap:18px;flex-wrap:wrap;')}>
            {LEGAL_LINKS.map(([href, label]) => (
              <Fragment key={href}>
                <A href={href} style={s('color:#66707C;')} className={linkHover}>
                  {label}
                </A>
              </Fragment>
            ))}
          </span>
        </div>
      </div>
    </footer>
  )
}
